import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { BRAND } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B0B0B] border-t border-white/5 pt-24 pb-10 mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          {/* Brand */}
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 text-white/60 max-w-sm leading-relaxed">
              {BRAND.tagline} Premium technology, AI automation, and growth
              partnerships for ambitious enterprises.
            </p>

            <div className="mt-8 flex items-center gap-3">
              <span className="pulse-dot" />
              <span className="text-xs uppercase tracking-[0.2em] text-white/50">
                Now accepting Q1 2026 partnerships
              </span>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-2">
            <h4 className="overline mb-5">Explore</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link className="hover:text-[#D4AF37] transition-colors" to="/">Home</Link></li>
              <li><Link className="hover:text-[#D4AF37] transition-colors" to="/services">Services</Link></li>
              <li><Link className="hover:text-[#D4AF37] transition-colors" to="/portfolio">Work</Link></li>
              <li><Link className="hover:text-[#D4AF37] transition-colors" to="/insights">Insights</Link></li>
              <li><Link className="hover:text-[#D4AF37] transition-colors" to="/about">About</Link></li>
              <li><Link className="hover:text-[#D4AF37] transition-colors" to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-5">
            <h4 className="overline mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${BRAND.email}`}
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>{BRAND.phone}</li>
              <li>{BRAND.address}</li>
            </ul>
          </div>
        </div>

        <div className="gold-divider mb-8" />

        {/* Massive brand wordmark */}
        <div className="font-display text-[18vw] md:text-[14vw] leading-[0.85] tracking-tighter text-white/[0.04] select-none pointer-events-none">
          ELEVARA
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mt-12 text-xs text-white/40">
          <div>© 2026 Elevara by Innapax. All Rights Reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#D4AF37] transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-[#D4AF37] transition-colors">Terms of Service</a>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F0C84B]"
            >
              Start Project <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
